import { EnquiryForm } from "./EnquiryForm";
import { FORMS } from "./formConfig";

export default function ReferralForm() {
  return <EnquiryForm config={FORMS.referral} />;
}
